import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { Storyboard } from 'app/models/storyboard';
import {  UPTOPResult } from 'app/models/uptop';
import { CompetitionService } from 'app/services/competition.service';
import {IAssetsService} from 'app/models/asset.service.interface';
import {Router} from '@angular/router'
@Injectable({
  providedIn: 'root'
})
export class StoryboardService implements IAssetsService{

  private apiUrl = environment.api.url + environment.api.content.url;

  constructor(private http: HttpClient, private competitionService: CompetitionService, private router: Router) {}

  getAll(lastEvaluatedKey?: any, index?:string): Observable<UPTOPResult> {
    let params = new HttpParams();
    params = params.append('competition', this.competitionService.getCompetitionId());
    params = params.append('op', environment.api.content.type.assets.op);
    params = params.append('source', environment.api.content.type.assets.storyboard);
    params = (index)?params.append('filter', index):params;
    if (this.router.url.split('/').filter(s => s).length <= 1){
        params = params.append("view","user");
    }
    let headers = new HttpHeaders();
    if (lastEvaluatedKey) {
      headers = headers.append('lastevaluatedkey', btoa(JSON.stringify(lastEvaluatedKey)));
    }

    return this.http
      .get<UPTOPResult>(this.apiUrl, { headers, params })
      .pipe(
        map((res) => res as UPTOPResult),
        catchError(err => throwError(err || 'ServerErr'))
      );
  }

  getById(id): Observable<Storyboard> {
    let params = new HttpParams();
    params = params.append('op', environment.api.content.type.asset.op);
    params = params.append('asset', id);

    return this.http
      .get<Storyboard>(this.apiUrl, { params })
      .pipe(
        catchError(err => throwError(err || 'ServerErr'))
      );
  }

  create(storyboard: Storyboard): Observable<Storyboard> {
    storyboard.updateDate = new Date().getTime();
    return this.http
      .post<Storyboard>(this.apiUrl, storyboard)
      .pipe(
        map(res => <Storyboard>res),
        catchError(err => throwError(err || 'ServerErr'))
      );
  }

  update(storyboard: Storyboard): Observable<Storyboard> {
    storyboard.updateDate = new Date().getTime();
    return this.http
      .put<Storyboard>(this.apiUrl, storyboard)
      .pipe(
        map(res => <Storyboard>res),
        catchError(err => throwError(err || 'ServerErr'))
      );
  }

  delete(id: string): Observable<Storyboard> {
    let params = new HttpParams();
    params = params.append('op', environment.api.content.type.assets.op);
    params = params.append('element', id);

    return this.http
      .delete<Storyboard>(this.apiUrl, { params })
      .pipe(
        map(res => <Storyboard>res),
        catchError(err => throwError(err || 'ServerErr'))
      );
  }
}
